<div class="store-details-list">
  <div *ngFor="let store of stores">
    <app-store-details-card [store]="store"></app-store-details-card>
  </div>
</div>
